module.exports = __webpack_public_path__ + "static/media/datacamp.005734da.png";